[
  {
    "id": "coin",
    "label": "Coin",
    "effect": "score",
    "value": 10,
    "color": "#ffd23f",
    "shape": "ring",
    "scale": 1,
    "sound": "coin"
  },
  {
    "id": "gem",
    "label": "Gem",
    "effect": "score",
    "value": 100,
    "color": "#46d5f2",
    "shape": "gem",
    "scale": 1.2,
    "sound": "gem"
  },
  {
    "id": "heart",
    "label": "Extra Life",
    "effect": "life",
    "value": 1,
    "color": "#ff5c7a",
    "shape": "sphere",
    "scale": 1.1,
    "sound": "power"
  },
  {
    "id": "boots",
    "label": "Speed Boots",
    "effect": "speed",
    "value": 1.8,
    "duration": 8,
    "color": "#8affc1",
    "shape": "box",
    "scale": 1,
    "sound": "power"
  },
  {
    "id": "feather",
    "label": "High Jump",
    "effect": "jump",
    "value": 1.45,
    "duration": 10,
    "color": "#c79bff",
    "shape": "gem",
    "scale": 1,
    "sound": "power"
  },
  {
    "id": "clock",
    "label": "+15 Seconds",
    "effect": "time",
    "value": 15,
    "color": "#ffa552",
    "shape": "ring",
    "scale": 1.1,
    "sound": "power"
  }
]
